import './App.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router';
import DataPlatform from './pages/app/dataplatform/DataPlatform';
import LoginPage from './pages/auth/LoginPage';
import ProfilePage from './pages/app/profile/ProfilePage';
import AdminPage from './pages/app/admin/AdminPage';
import ProtectedRoute from './components/hoc/ProtectedRoute';
import AppTabs from './pages/app/AppTabs';

import { ThemeProvider, useTheme } from './theme/ThemeContext';
import AgentTable from './components/agents/AgentsTable';
import LogsTable from './components/logs/LogsTable';
import LFDsTable from './components/lfds/LFDsTable';
import RASDSTsTable from './components/rasdsts/RASDSTsTable';
import DatasetsTable from './components/dataset/DatasetsTable';
import MlModelsTable from './components/mlModels/MlModelsTable';
import PeoplePage from './pages/app/people/PeoplePage';
import RolePage from './pages/app/role/RolePage';
import LicensePage from './pages/app/licenses/LicensePage';
import ActuatorTestTable from './components/actuator_test/ActuatorTestTable';

// Import useEffect for side effects in functional components
import { useEffect } from 'react';

// --- SERVICE WORKER REGISTRATION CODE ---
// This part is new and crucial for streamsaver
function registerServiceWorker() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.register('/sw.js')
      .then(registration => {
        console.log('Service Worker registered successfully:', registration);
      })
      .catch(error => {
        console.error('Service Worker registration failed:', error);
      });
  } else {
    console.warn('Service Workers are not supported in this browser. Streaming downloads may not work for large files.');
  }
}
// --- END SERVICE WORKER REGISTRATION CODE ---


function AppContent() {
  const { toggleDarkMode } = useTheme();

  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Navigate to="/app/dataplatform/logs" />
            </ProtectedRoute>
          }
        />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/app/*"
          element={
            <ProtectedRoute>
              <AppTabs />
            </ProtectedRoute>
          }
        >
          <Route path="profile" element={<ProfilePage />} />
          <Route path="dataplatform" element={<DataPlatform />} >
            <Route path="logs" element={<LogsTable />} />
            <Route path="lfds" element={<LFDsTable />} />
            <Route path="rasdsts" element={<RASDSTsTable />} />
            <Route path="datasets" element={<DatasetsTable />} />
            <Route path="actuator_test" element={<ActuatorTestTable />} />
            <Route path="agents" element={<AgentTable />} />
          </Route>
          <Route path="people" element={<PeoplePage />} />
          <Route path="role" element={<RolePage />} />
          <Route path="licenses" element={<LicensePage />} />
          <Route path="admin" element={<AdminPage />} />
        </Route>
      </Routes>
    </Router>
  );
}

function App() {
  // Use useEffect to register the Service Worker once when the component mounts
  useEffect(() => {
    registerServiceWorker();
  }, []); // Empty dependency array ensures it runs only once

  return (
    <ThemeProvider>
      <div className="App">
        <AppContent />
      </div>
    </ThemeProvider>
  );
}

export default App;